'use strict';
import {Headers} from 'whatwg-fetch';

export default class JwtAuthSettings {
  constructor(token = null) {
    this._token = token;
  }

  get token() {
    return this._token;
  }

  authenticateHeader(headers = undefined) {
    if (headers === undefined) {
      headers = new Headers();
    }
    headers.Authorization = 'Bearer ' + this.token;
    return headers;
  }
}
